<div class="select">
  <div
    class="select-input"
    [ngClass]="{
      'select-input-opened': optionsVisible,
      'no-border': noBorder,
      disabled: disabled,
      'select-input-invalid': !isFormValid,
    }"
    (click)="inputOnClick()"
  >
    <div class="select-input-value" *ngIf="selectedId">
      <img
        *ngIf="optionsById.get(selectedId)?.iconPath"
        [src]="optionsById.get(selectedId)?.iconPath"
        class="option-img"
      />
      <div class="select-input-value-text" appLongTextTooltip>
        {{ withoutShowingSelection && optionsById.size > 0 ? '' : optionsById.get(selectedId)?.displayName }}
      </div>
    </div>
    <div class="select-input-placeholder" *ngIf="!selectedId">
      {{ placeHolder }}
    </div>
    <img
      *ngIf="canBeEmpty && selectedId"
      src="assets/images/common/cancel-grey.svg"
      class="cancel-img"
      (click)="clearSelection(); $event.stopPropagation()"
    />
    <img src="assets/images/arrows/empty-arrow-down.svg" class="drop-down" alt="expand" />
  </div>
  <div class="select-options" *ngIf="optionsVisible" (clickOutside)="onClickOutside()" [delayClickOutsideInit]="true">
    <div
      *ngFor="let option of options$ | async; index as i"
      class="select-option"
      [ngClass]="{
        'select-option-selected': option.id === selectedId,
        'select-option-disabled': option.disabled,
      }"
      (click)="onSelect(option.id); $event.stopPropagation()"
      [matTooltip]="option.tooltip ? option.tooltip : ''"
      matTooltipPosition="above"
      matTooltipClass="tooltip-container"
    >
      <img *ngIf="option.iconPath" [src]="option.iconPath" class="option-img" />
      <div class="option-text" appLongTextTooltip>
        {{ option.displayName }}
      </div>
    </div>
  </div>
</div>
